import "./PhoneNumberInput.scss";

import { useState } from "react";
import PhoneInput from "react-phone-input-2";
import { useTranslation } from "react-i18next";

require("react-phone-input-2/lib/material.css");
interface PhoneNumberInputProps {
  onChange: (e: any) => void;
  value: string;
  onBlur?: (e: any) => void;
}
const PhoneNumberInput = ({
  onChange,
  value,
  onBlur,
}: PhoneNumberInputProps) => {
  const [phone, setPhone] = useState<string>(value);
  const { t } = useTranslation();

  return (
    <PhoneInput
      country={"pl"}
      containerClass="phone-input-container"
      inputClass="phone-input"
      dropdownClass="phone-dropdown"
      enableSearch={true}
      countryCodeEditable={false}
      searchPlaceholder={t("exchange.formContent.phonePlaceholder")}
      specialLabel={t("exchange.formContent.phoneNumber")}
      onBlur={onBlur}
      value={phone}
      onChange={(e) => {
        setPhone(e);
        onChange(e);
      }}
    />
  );
};

export default PhoneNumberInput;
